import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PointsSummary } from '@rd/types';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { LoadPointsSummary } from '../../store/actions/points-summary.actions';
import {
  getPointsSummary,
  getPointsSummaryBalance,
  getPointsSummaryError,
  getPointsSummaryLoading,
} from '../../store/reducers';
import { PointsSummaryState } from '../../store/reducers/points-summary.reducer';

@Injectable()
export class PointsSummaryFacade {
  constructor(private store: Store<PointsSummaryState>) {}

  pointsSummaryError$: Observable<boolean> = this.store
    .select(getPointsSummaryError)
    .pipe(map(Boolean), distinctUntilChanged());

  pointsSummary$: Observable<PointsSummary | null> = this.store
    .select(getPointsSummary)
    .pipe(distinctUntilChanged());

  pointsSummaryBalance$: Observable<number> = this.store
    .select(getPointsSummaryBalance)
    .pipe(distinctUntilChanged());

  pointsSummaryLoading$: Observable<boolean> = this.store
    .select(getPointsSummaryLoading)
    .pipe(distinctUntilChanged());

  loadPointsSummary(): void {
    this.store.dispatch(new LoadPointsSummary());
  }
}
